export let noneGroupHeader = "A3YVjc";
export default {noneGroupHeader};